import i18n from "i18n-js";

export const buildErrorStringCreateUser = (data) => {
  let result = '';
  if (data.phone) {
    result += i18n.t('labels.phoneAlreadyExists');
    result += '\n';
  }
  if (data.email) {
    result += i18n.t('labels.emailAlreadyExists');
    result += '\n';
  }
  return result;
}



// WEBPACK FOOTER //
// ./src/scripts/utils/errorUtils.js